import { render, staticRenderFns } from "./RankingList.vue?vue&type=template&id=22c0991d&scoped=true&"
import script from "./RankingList.vue?vue&type=script&lang=js&"
export * from "./RankingList.vue?vue&type=script&lang=js&"
import style0 from "./RankingList.vue?vue&type=style&index=0&id=22c0991d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c0991d",
  null
  
)

export default component.exports